import React, { useState } from 'react';
import axios from 'axios';
import DashHeader from '../components/DashHeader';
import DashSide from '../components/DashSide';

const AddBook = () => {
  const [title, setTitle] = useState('');
  const [bookCoverUrl, setBookCoverUrl] = useState('');
  const [bookUrl, setBookUrl] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const bookData = {
      title: title,
      book_cover_url: bookCoverUrl,
      book_url: bookUrl,
    };

    try {
     axios.post('https://cacityofgod.pythonanywhere.com/citizen/upload_book/', bookData)
        .then((response) => {
          if (response) {
            setMessage('Book added successfully!');
            // Clear the form fields
            setTitle('');
            setBookCoverUrl('');
            setBookUrl('');
          }
      })

      
    } catch (error) {
      setMessage('Failed to add the book. Please try again.');
    }
  };

  return (
    <div className="w-screen h-screen bg-gray-100 flex">
      <div className="fixed top-0 left-0 w-full">
        <DashHeader />
      </div>
      <div className="fixed top-16 left-0 h-screen">
        <DashSide />
      </div>
      <div className="ml-60 p-8 w-full bg-white shadow-md rounded">
        <h2 className="text-2xl font-bold mb-6">Add a New Book</h2>
        {message && <p className="mb-4 text-red-500">{message}</p>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="title">
              Book Title
            </label>
            <input
              type="text"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Enter book title"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="bookCoverUrl">
              Book Cover URL
            </label>
            <input
              type="text"
              id="bookCoverUrl"
              value={bookCoverUrl}
              onChange={(e) => setBookCoverUrl(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Enter book cover URL"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="bookUrl">
              Book URL
            </label>
            <input
              type="text"
              id="bookUrl"
              value={bookUrl}
              onChange={(e) => setBookUrl(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Enter book URL"
              required
            />
          </div>
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Add Book
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBook;
